export const CUSTOM_BR_CONTROL_ID = 'custom-br-control';
